<h1 mat-dialog-title>Jurisdiction Details</h1>

<div mat-dialog-content [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
        <mat-label>UBO Percentage</mat-label>
        <input matInput formControlName="uboPercentage" type="number">
        <mat-error *ngIf="form.get('uboPercentage')?.hasError('required')">
            UBO % is required.
        </mat-error>
        <mat-error *ngIf="form.get('uboPercentage')?.hasError('min')">
            UBO % cannot be negative.
        </mat-error>
        <mat-error *ngIf="form.get('uboPercentage')?.hasError('max')">
            UBO % cannot exceed 100.
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Fallback Matter ID</mat-label>
        <input matInput formControlName="fallbackMatterId">
        <mat-error *ngIf="form.get('fallbackMatterId')?.hasError('required')">
            Fallback Matter ID is required.
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Individual Charge</mat-label>
        <input matInput formControlName="individualCharge" type="number">
        <mat-error *ngIf="form.get('individualCharge')?.hasError('required')">
            Individual Charge is required.
        </mat-error>
        <mat-error *ngIf="form.get('individualCharge')?.hasError('min')">
            Value cannot be negative.
        </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>Company Charge</mat-label>
        <input matInput formControlName="companyCharge" type="number">
        <mat-error *ngIf="form.get('companyCharge')?.hasError('required')">
            Company Charge is required.
        </mat-error>
        <mat-error *ngIf="form.get('companyCharge')?.hasError('min')">
            Value cannot be negative.
        </mat-error>
    </mat-form-field>
</div>

<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="primary" (click)="save()">Save</button>
</div>
